// extracted by mini-css-extract-plugin
export var category = "styles-module--category--41e23";
export var contenders = "styles-module--contenders--e4ac6";
export var country = "styles-module--country--466b3";
export var header = "styles-module--header--190db";
export var icon = "styles-module--icon--75d2a";
export var position = "styles-module--position--4d372";
export var preview = "styles-module--preview--717f0";
export var rank = "styles-module--rank--c136c";
export var ranking = "styles-module--ranking--1269b";
export var rankingItem = "styles-module--rankingItem--c9458";
export var subtitle = "styles-module--subtitle--8943b";
export var text = "styles-module--text--6c1a6";
export var title = "styles-module--title--1ac4d";